import {
    GET_CALENDAR_SETTINGS,
    GET_CALENDAR_SETTINGS_SUCCESS,
    GET_CALENDAR_SETTINGS_FAILURE,
    GENERATE_NEW_CALENDAR_SHARING_LINK,
    UPDATED_CALENDAR_SHARE_LINK_SUCCESS,
    UPDATED_CALENDAR_SHARE_LINK_FAILURE,
    SET_SETTINGS_POP_UP,
    IS_SETTING_PAGE_UPDATE,
    IS_GENERATED_LINK_UPDATE,
    UPDATE_TURN_ON_GENERATED_LINK,
    SET_CANCEL_CALENDAR_SHARING,
    CANCEL_CALENDAR_SHARING_SUCCESS,
    CANCEL_CALENDAR_SHARING_FAILURE,
    SET_SETTINGS_VALUE,
    SET_COMPACT_VIEW_TOGGLE,
    SET_HIDE_CONDENSED_VIEW_TOGGLE,
    SET_IS_DELETE,
} from '../actions';

const initialState = {
    loading: false,
    calendarSettings: {
        isCalendarSharing: false,
        defaultView: 'month',
        calendarSharingAddress: '',
        calendarSharingAddressGeneratedDate: '',
    },
    notificationSettings: {
        mobilePhoneNumber: '',
        currentEmailAddress: '',
        alternateEmailAddress: '',
        backOrder: null,
        replenBackOrderShipment: null,
        extraItemCancellation: null,
        unidDraftOrderInitiated: null,
        unidPlanNotComplete: null,
        unidUsagePending: null,
        unidPlanUpdates: null,
    },
    statusCode: '',
    statusMessage: '',
    newLinkData: {},
    linkLoading: false,
    settingUpdateInProgress: false,
    isSettingPageUpdate: false,
    isGeneratedLinkUpdate: false,
    settingsValue: false,
    condensedView: false,
    hideCondensedViewToggle: false,
    isDelete: false
};

const GetCalendarSettings = (state = initialState, action) => {
    switch (action.type) {
        case GET_CALENDAR_SETTINGS:
            return {
                ...state,
                loading:
                    action.payload?.isUpdateLink && action.payload.isUpdateLink
                        ? state.loading
                        : true,
            };
        case GET_CALENDAR_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.payload,
            };
        case GET_CALENDAR_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case UPDATED_CALENDAR_SHARE_LINK_SUCCESS:
            return {
                ...state,
                linkLoading: false,
                newLinkData: action.payload,
            };
        case GENERATE_NEW_CALENDAR_SHARING_LINK: {
            return {
                ...state,
                linkLoading: true,
            };
        }
        case UPDATED_CALENDAR_SHARE_LINK_FAILURE:
            return {
                ...state,
                linkLoading: false,
            };
        case SET_SETTINGS_POP_UP:
            return {
                ...state,
                settingUpdateInProgress: action.payload,
            };
        case IS_SETTING_PAGE_UPDATE:
            return {
                ...state,
                ...action.payload,
            };
        case IS_GENERATED_LINK_UPDATE:
            return {
                ...state,
                ...action.payload,
            };
        case UPDATE_TURN_ON_GENERATED_LINK:
            return {
                ...state,
                calendarSettings: {
                    ...state.calendarSettings,
                    ...action.payload,
                },
            };
        case SET_CANCEL_CALENDAR_SHARING:
            return {
                ...state,
                loading: true,
            };
        case CANCEL_CALENDAR_SHARING_SUCCESS:
            return {
                ...state,
                loading: false,
                calendarSettings: {
                    ...state.calendarSettings,
                    ...action.payload,
                },
            };
        case CANCEL_CALENDAR_SHARING_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case SET_SETTINGS_VALUE:
            return {
                ...state,
                settingsValue: action.payload,
            };
        case SET_COMPACT_VIEW_TOGGLE:
            return {
                ...state,
                condensedView: action.payload,
            };
        case SET_HIDE_CONDENSED_VIEW_TOGGLE:
            return {
                ...state,
                hideCondensedViewToggle: action.payload,
            };
        case SET_IS_DELETE:
            return {
                ...state,
                isDelete: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default GetCalendarSettings;
